import React, { useMemo } from 'react'
import { Avatar, Badge } from 'antd'
import styles from './UserAvatar.module.css'
import { fontSize, width } from '@xstyled/styled-components'
import { height } from '@mui/system'

const ColorList = ['#f56a00', '#7265e6', '#00a2ae']

function UserAvatar({
  hasBadge,
  userName,
  shape,
  size,
  width,
  height,
  fontSize,
  cursor,
}) {
  const name = userName || ''
  const initials =
    name && name.length >= 2 ? name.substring(0, 2).toUpperCase() : ''

  const randomColor = useMemo(() => {
    return ColorList[Math.floor(Math.random() * ColorList.length)]
  }, [userName])

  const avatar = (
    <Avatar
      size={size}
      shape={shape}
      className={styles.button}
      style={{
        backgroundColor: randomColor,
        width: width,
        minWidth: width,
        fontSize: fontSize,
        minHeight: height,
        height: height,
        cursor: cursor,
      }}
    >
      {initials}
    </Avatar>
  )

  return (
    <div className={styles.container}>
      {hasBadge ? (
        <Badge dot status="success">
          {avatar}
        </Badge>
      ) : (
        avatar
      )}
    </div>
  )
}

export default UserAvatar
